/** Role 4 partner who registered via LeadScale. */
export function isLeadScalePartner(user) {
  return (
    Number(user?.id_role) === 4 &&
    String(user?.register_source || '').toLowerCase() === 'leadscale'
  );
}

/** Role 11 advertiser. */
export function isAdvertiserRole(user) {
  return Number(user?.id_role) === 11;
}

/** Advertiser (11) or LeadScale-registered partner (4) — portal branding + host. */
export function isLeadScalePortalUser(user) {
  return isAdvertiserRole(user) || isLeadScalePartner(user);
}

/** Canonical LeadScale panel origin (prod HTTPS / local hosts → :3000). */
export function getLeadScaleAppOrigin() {
  if (typeof window !== 'undefined') {
    const host = String(window.location.hostname || '').toLowerCase();
    if (host === 'app.leadscaleglobal.com' || host === 'advertiser.exodopanel.com') {
      return window.location.origin;
    }
  }
  if (process.env.NODE_ENV === 'development') {
    return 'http://app.leadscaleglobal.com:3000';
  }
  return 'https://app.leadscaleglobal.com';
}

/** Full URL for LeadScale default panel landing. */
export function getLeadScaleLeadsUrl() {
  return `${getLeadScaleAppOrigin()}/panel/lms/leads`;
}

/** Who may see Revenue / Profit columns on Leads (super admin + cogs admin only). */
export function canSeeAdvertiserLeadFinance(user) {
  const role = Number(user?.id_role);
  return role === 1 || role === 9;
}

/** Admin Advertiser stats / details / balance (not role 11). */
export function canSeeAdminAdvertiserStats(user) {
  const role = Number(user?.id_role);
  return role === 1 || role === 9;
}

/** Advertiser filter dropdown on Leads (not role 11). */
export function canUseAdvertiserLeadFilter(user) {
  const role = Number(user?.id_role);
  return role === 1 || role === 9 || isLeadScalePartner(user);
}
